import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faFire } from '@fortawesome/free-solid-svg-icons';
import { ExtinctionData } from './feactures/dataProvider';
import { ModalNotify } from './Modals';


const ItemsStand_RA = ({price, descrpShort, title, video, visual, onBuy}) => {


    if(video){
        return(
            <div className='items_stand_structurer_ra'>
                <div className='preview_section_item_ra'>
                    <span className='title_item_stand_blackm'>{title}</span>
                    <video src={visual} alt={title} className='img_item_stand'/>
                    <span className='caption_item_stand_blackm'>{descrpShort}</span>
                </div>
                <div className='cta_structurer_ra' onClick={onBuy}>
                    <span className='amount_item_price_stand_ra'>{price} RP</span>
                    <span className='cta_msg_stand_ra'>BUY NOW</span>
                </div>
            </div>
        )
    }

    return(
        <div className='items_stand_structurer_ra'>
            <div className='preview_section_item_ra'>
                <span className='title_item_stand_blackm'>{title}</span>
                <img src={visual} alt={title} className='img_item_stand'/>
                <span className='caption_item_stand_blackm'>{descrpShort}</span>
            </div>
            <div className='cta_structurer_ra' onClick={onBuy}>
                <span className='amount_item_price_stand_ra'>{price} RP</span>
                <span className='cta_msg_stand_ra'>BUY NOW</span>
            </div>
        </div>
    )
}

const Slides = ({slide, onBuy}) => {

    if(slide === 0){
        return (
            <>
            <span className='tag_special_ra'>Special Sales</span>
            <img src="https://extinctionwars.com/assets/img/app-resources/ra_shop/colonist_box.png" alt={'Colonist Box'} className='img_item_stand_ra'/>
            <div className='bottom_info_structuer_ra' onClick={() => onBuy('item5')}>
                <div className='info_item_box_ra'>
                    <span className='item_special_title_ra'>Colonist Box</span>
                </div>
                <div className='cta_item_box_ra'>
                    <span className='price_ra_special'>500 RP</span>
                    <span className='cta_btn_special_ra'>BUY NOW</span>
                </div>
            </div>
            </>
        )
    }

    if(slide === 1){
        return (
            <>
            <span className='tag_special_ra'>Special Sales</span>
            <img src="https://extinctionwars.com/assets/img/app-resources/blackmarket/trainkit_sale.png" alt={'Training Kit'} className='img_item_stand_ra'/>
            <div className='bottom_info_structuer_ra' onClick={() => onBuy('item8')}>
                <div className='info_item_box_ra'>
                    <span className='item_special_title_ra'>Train Kit</span>
                </div>
                <div className='cta_item_box_ra'>
                    <span className='price_ra_special'>5 RP</span>
                    <span className='cta_btn_special_ra'>BUY NOW</span>
                </div>
            </div>
            </>
        )
    }

    if(slide === 2){
        return (
            <>
            <span className='tag_special_ra'>Special Sales</span>
            <img src="https://extinctionwars.com/assets/img/app-resources/blackmarket/suit_crate.png" alt={'Suit Crate'} className='img_item_stand_ra'/>
            <div className='bottom_info_structuer_ra' onClick={() => onBuy('item2')}>
                <div className='info_item_box_ra'>
                    <span className='item_special_title_ra'>Suit Crate</span>
                </div>
                <div className='cta_item_box_ra'>
                    <span className='price_ra_special'>76 RP</span>
                    <span className='cta_btn_special_ra'>BUY NOW</span>
                </div>
            </div>
            </>
        )
    }

    if(slide === 3){
        return (
            <>
            <span className='tag_special_ra'>Special Sales</span>
            <img src="https://extinctionwars.com/assets/img/app-resources/blackmarket/weapon_crate.png" alt={'Weapon Crate'} className='img_item_stand_ra'/>
            <div className='bottom_info_structuer_ra' onClick={() => onBuy('item3')}>
                <div className='info_item_box_ra'>
                    <span className='item_special_title_ra'>Weapon Crate</span>
                </div>
                <div className='cta_item_box_ra'>
                    <span className='price_ra_special'>77 RP</span>
                    <span className='cta_btn_special_ra'>BUY NOW</span>
                </div>
            </div>
            </>
        )
    }

    if(slide === 4){
        return (
            <>
            <span className='tag_special_ra'>Special Sales</span>
            <img src="https://extinctionwars.com/assets/img/app-resources/blackmarket/double_crate.png" alt={'Double Crate'} className='img_item_stand_ra'/>
            <div className='bottom_info_structuer_ra' onClick={() => onBuy('item1')}>
                <div className='info_item_box_ra'>
                    <span className='item_special_title_ra'>Double Crate</span>
                </div>
                <div className='cta_item_box_ra'>
                    <span className='price_ra_special'>122 RP</span>
                    <span className='cta_btn_special_ra'>BUY NOW</span>
                </div>
            </div>
            </>
        )
    }
}

const SpecialItems_RA = ({onBuy}) => {
    
    const [slideId, setSlideId] = useState(0);

    useEffect(() => {
        let slideShow = null;

        slideShow = setInterval(nextSlide, 6000);

        return () => {
            clearInterval(slideShow);
        }
    
    }, [slideId])
    

    const nextSlide = () => {
        if(slideId === 4){
            setSlideId(0);
        }
        else {
            setSlideId(slideId + 1)
        }
    }

    const prevSlide = () => {
        if(slideId === 0){
            setSlideId(4);
        }
        else {
            setSlideId(slideId - 1)
        }
    }

    return (
        <div className='special_items_container'>
            <button className='btn_control left' onClick={() => prevSlide()}><FontAwesomeIcon icon={faAngleLeft} size='xl'/></button>
            <button className='btn_control right' onClick={() => nextSlide()}><FontAwesomeIcon icon={faAngleRight} size='xl'/></button>
            <div className='special_items_structurer'>
                <Slides slide={slideId} onBuy={onBuy}/>
            </div>
        </div>
    )
}

export const ShopRpoints = ({userData}) => {

    const [nofity, setNotify] = useState({
        status: false,
        error: false,
        title: '',
        msg: '',
        txId: '',
    })

  
  const purchaseRa = async(id_item) => {
    if(userData.whichProvider === 'Anchor'){
        try{
          const action = {
            account: ExtinctionData.EXTINCTION_CONTRACT,
            name: 'radiationbuy',
            authorization: [userData.auths],
            data: {
              account: userData.username,
              option: id_item,
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {

          })
        }catch(err){
          
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
          try{
              const action = {
                  actions: [{
                      account: ExtinctionData.EXTINCTION_CONTRACT,
                      name: 'radiationbuy',
                      authorization: [{
                          actor: userData.username,
                          permission: 'active',
                        }],
                      data: {
                        account: userData.username,
                        option: id_item,
                        },
                  }],
              }
              const transaction = await userData.sessionData.api.transact(action, {
                  blocksBehind: 3,
                  expireSeconds: 1200,
                });
                setNotify({
                  status: true,
                  error: false,
                  title: 'Success',
                  msg: 'Transaction Id:',
                  txId: transaction.transaction_id,
                });  
            }
            catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
            }
      }
  }  

  return (
    <>
    {nofity.status && 
    <div style={{width: '100%', display: 'flex', justifyContent: 'center', position: 'absolute'}}>
    <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })}}/>
    </div>
    }
    <SpecialItems_RA onBuy={purchaseRa}/>
    <div className='items_stands_container_ra'>
        <ItemsStand_RA title='20 Neodymium' descrpShort='Package' price='10' visual={'https://extinctionwars.com/assets/img/app-resources/ra_shop/neo_ra.png'} onBuy={() => purchaseRa('item6')}/>
        <ItemsStand_RA title='20 Chalcedony' descrpShort='Package' price='10' visual={'https://extinctionwars.com/assets/img/app-resources/ra_shop/chal_ra.png'} onBuy={() => purchaseRa('item7')}/>
        <ItemsStand_RA title='Legendary' descrpShort='Reward Box' price='4' video={true} visual={'https://extinctionwars.com/assets/videos/visuals/boxes-crates/lcouncil.mp4'} onBuy={() => purchaseRa('item4')}/>
    </div>
    </>
  )
}
